<script>
    import Vue from 'vue'
    import axios from 'axios'
    import {ConsoleLogger} from '@/console-logger'
    import { mapGetters } from 'vuex';

    export default {
        name: 'api-client-core',
        data() {
            return {
                logger: new ConsoleLogger('ApiClient', 'background: #0000aa; color: white', null),
                http: null,
                lastResponse: null
            }
        },
        created() {
            if (!Vue.prototype.$apiClient) {
                Object.defineProperty(Vue.prototype, '$apiClient', {value: this})

                this.logger.logMessage(`Assigned to Vue.$apiClient`)
            }

            this.http = axios.create({
                timeout: 5000,
                baseURL: this.appConfig.baseApiUrl,
            });
        },
        computed: {
            ...mapGetters({
                appConfig: 'getAppConfig',
            })
        },
        methods: {
            get(endPoint) {
                return this.request('get', endPoint, {});
            },
            post(endPoint, data) {
                return this.request('post', endPoint, data);
            },
            put(endPoint, data) {
                return this.request('put', endPoint, data);
            },
            delete(endPoint, data) {
                return this.request('delete', endPoint, data);
            },
            request(type, endPoint, data) {
                let typePrint = type.toUpperCase()

                this.logger.logMessage(`${typePrint} ${endPoint}`)

                return this.http[type](endPoint, data).then((response) => {
                    this.lastResponse = response;

                    if (response && response.hasOwnProperty('data')) {
                        let data = response.data;
                        let httpCode = data.hasOwnProperty('httpCode') ? data.httpCode : null;

                        this.logger.logMessage(`${typePrint} ${endPoint} | SUCCESS [${httpCode}]`)

                        if (httpCode === 200) {
                            if (response.data.hasOwnProperty('data')) {
                                return response.data.data;
                            } else {
                                return null;
                            }
                        } else {
                            let error = 'Unknown';

                            if (data.hasOwnProperty('error') && data.error.hasOwnProperty('message')) {
                                error = data.error.message;
                            }

                            this.logger.logMessage(`${typePrint} ${endPoint} | ERROR | ${error}`)

                            return Promise.reject(error);
                        }

                    } else {
                        this.logger.logMessage(`${typePrint} ${endPoint} | ERROR | Could not find any data in response`)

                        return Promise.reject('Could not find any data in response');
                    }
                }).catch((error) => {
                    if (error.response) {
                        this.lastResponse = error.response;
                    } else {
                        this.lastResponse = null;
                    }

                    this.logger.logMessage(`${typePrint} ${endPoint} | ERROR | Could not execute request: ${error}`)

                    throw error
                })
            },
            setBaseUrl(baseUrl) {
                this.logger.logMessage(`Set API base URL to ${baseUrl}`)

                this.http.defaults.baseURL = baseUrl
            },
            getBaseUrl() {
                return this.http.defaults.baseURL;
            },
            setBearerToken(token) {
                if (token) {
                    this.http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                } else {
                    delete this.http.defaults.headers.common['Authorization'];
                }
            }
        },
        render: function (h) {
            return h() // avoid warning message
        }
    }
</script>
